// Auto-generated file with top 50 exchanges from CoinGecko
// Last updated: 2025-05-27T04:21:57.024Z
// Total exchanges: 50

export interface ExchangeData {
  id: string;
  name: string;
  image: string;
  year_established: number | null;
  country: string | null;
  trust_score: number;
  trust_score_rank: number;
  trade_volume_24h_btc: number;
  rank: number;
}

export const TOP_50_EXCHANGES: ExchangeData[] = [
  {
    "id": "binance",
    "name": "Binance",
    "image": "/exchange-logos/binance.png",
    "year_established": 2017,
    "country": "Cayman Islands",
    "trust_score": 10,
    "trust_score_rank": 1,
    "trade_volume_24h_btc": 114951.96876963347,
    "rank": 1
  },
  {
    "id": "bybit_spot",
    "name": "Bybit",
    "image": "/exchange-logos/bybit_spot.png",
    "year_established": 2018,
    "country": "British Virgin Islands",
    "trust_score": 10,
    "trust_score_rank": 2,
    "trade_volume_24h_btc": 31353.486325521153,
    "rank": 2
  },
  {
    "id": "okex",
    "name": "OKX",
    "image": "/exchange-logos/okex.png",
    "year_established": 2017,
    "country": "Seychelles",
    "trust_score": 10,
    "trust_score_rank": 3,
    "trade_volume_24h_btc": 22423.049627949935,
    "rank": 3
  },
  {
    "id": "bitget",
    "name": "Bitget",
    "image": "/exchange-logos/bitget.png",
    "year_established": 2018,
    "country": "Seychelles",
    "trust_score": 10,
    "trust_score_rank": 4,
    "trade_volume_24h_btc": 24419.73177244921,
    "rank": 4
  },
  {
    "id": "gdax",
    "name": "Coinbase Exchange",
    "image": "/exchange-logos/gdax.png",
    "year_established": 2012,
    "country": "United States",
    "trust_score": 10,
    "trust_score_rank": 5,
    "trade_volume_24h_btc": 15886.457403093955,
    "rank": 5
  },
  {
    "id": "crypto_com",
    "name": "Crypto.com Exchange",
    "image": "/exchange-logos/crypto_com.png",
    "year_established": 2019,
    "country": "Malta",
    "trust_score": 10,
    "trust_score_rank": 6,
    "trade_volume_24h_btc": 19919.608064424294,
    "rank": 6
  },
  {
    "id": "kraken",
    "name": "Kraken",
    "image": "/exchange-logos/kraken.png",
    "year_established": 2011,
    "country": "United States",
    "trust_score": 10,
    "trust_score_rank": 7,
    "trade_volume_24h_btc": 7816.410226894233,
    "rank": 7
  },
  {
    "id": "kucoin",
    "name": "KuCoin",
    "image": "/exchange-logos/kucoin.png",
    "year_established": 2017,
    "country": "Seychelles",
    "trust_score": 10,
    "trust_score_rank": 8,
    "trade_volume_24h_btc": 9026.640952755279,
    "rank": 8
  },
  {
    "id": "backpack_exchange",
    "name": "Backpack Exchange ",
    "image": "/exchange-logos/backpack_exchange.png",
    "year_established": 2023,
    "country": "British Virgin Islands",
    "trust_score": 10,
    "trust_score_rank": 9,
    "trade_volume_24h_btc": 603.491583692638,
    "rank": 9
  },
  {
    "id": "binance_us",
    "name": "Binance US",
    "image": "/exchange-logos/binance_us.png",
    "year_established": 2019,
    "country": "United States",
    "trust_score": 10,
    "trust_score_rank": 10,
    "trade_volume_24h_btc": 77.48619238553312,
    "rank": 10
  },
  {
    "id": "arkham",
    "name": "Arkham",
    "image": "/exchange-logos/arkham.png",
    "year_established": 2024,
    "country": "Dominican Republic",
    "trust_score": 10,
    "trust_score_rank": 11,
    "trade_volume_24h_btc": 74.52265747414468,
    "rank": 11
  },
  {
    "id": "mxc",
    "name": "MEXC",
    "image": "/exchange-logos/mxc.png",
    "year_established": 2018,
    "country": "Seychelles",
    "trust_score": 9,
    "trust_score_rank": 12,
    "trade_volume_24h_btc": 25554.94657226396,
    "rank": 12
  },
  {
    "id": "huobi",
    "name": "HTX",
    "image": "/exchange-logos/huobi.png",
    "year_established": 2013,
    "country": "Seychelles",
    "trust_score": 9,
    "trust_score_rank": 13,
    "trade_volume_24h_btc": 25458.71940285652,
    "rank": 13
  },
  {
    "id": "gate",
    "name": "Gate",
    "image": "/exchange-logos/gate.png",
    "year_established": 2013,
    "country": "Panama",
    "trust_score": 9,
    "trust_score_rank": 14,
    "trade_volume_24h_btc": 31178.076657669615,
    "rank": 14
  },
  {
    "id": "whitebit",
    "name": "WhiteBIT",
    "image": "/exchange-logos/whitebit.png",
    "year_established": 2018,
    "country": "Lithuania",
    "trust_score": 9,
    "trust_score_rank": 15,
    "trade_volume_24h_btc": 9586.04311627543,
    "rank": 15
  },
  {
    "id": "bitunix",
    "name": "Bitunix",
    "image": "/exchange-logos/bitunix.png",
    "year_established": 2021,
    "country": "Saint Vincent and the Grenadines",
    "trust_score": 9,
    "trust_score_rank": 16,
    "trade_volume_24h_btc": 6729.217202474496,
    "rank": 16
  },
  {
    "id": "bitmax",
    "name": "AscendEX (BitMax)",
    "image": "/exchange-logos/bitmax.png",
    "year_established": 2018,
    "country": "Singapore",
    "trust_score": 9,
    "trust_score_rank": 17,
    "trade_volume_24h_btc": 9878.686799528394,
    "rank": 17
  },
  {
    "id": "pionex",
    "name": "Pionex",
    "image": "/exchange-logos/pionex.png",
    "year_established": 2019,
    "country": "British Virgin Islands",
    "trust_score": 9,
    "trust_score_rank": 18,
    "trade_volume_24h_btc": 4182.347300887655,
    "rank": 18
  },
  {
    "id": "bingx",
    "name": "BingX",
    "image": "/exchange-logos/bingx.png",
    "year_established": 2018,
    "country": "British Virgin Islands",
    "trust_score": 9,
    "trust_score_rank": 19,
    "trade_volume_24h_btc": 2860.306242910798,
    "rank": 19
  },
  {
    "id": "gemini",
    "name": "Gemini",
    "image": "/exchange-logos/gemini.png",
    "year_established": 2014,
    "country": "United States",
    "trust_score": 9,
    "trust_score_rank": 20,
    "trade_volume_24h_btc": 966.78399846118,
    "rank": 20
  },
  {
    "id": "bitkub",
    "name": "Bitkub",
    "image": "/exchange-logos/bitkub.png",
    "year_established": 2018,
    "country": "Thailand",
    "trust_score": 9,
    "trust_score_rank": 21,
    "trade_volume_24h_btc": 412.3147920206529,
    "rank": 21
  },
  {
    "id": "hashkey_exchange",
    "name": "HashKey Exchange",
    "image": "/exchange-logos/hashkey_exchange.png",
    "year_established": 2018,
    "country": "Hong Kong",
    "trust_score": 9,
    "trust_score_rank": 22,
    "trade_volume_24h_btc": 361.3283275544449,
    "rank": 22
  },
  {
    "id": "luno",
    "name": "Luno",
    "image": "/exchange-logos/luno.png",
    "year_established": 2013,
    "country": "Singapore",
    "trust_score": 9,
    "trust_score_rank": 23,
    "trade_volume_24h_btc": 113.59021488862535,
    "rank": 23
  },
  {
    "id": "hashkey-global",
    "name": "HashKey Global",
    "image": "/exchange-logos/hashkey-global.png",
    "year_established": 2018,
    "country": "Bermuda",
    "trust_score": 9,
    "trust_score_rank": 24,
    "trade_volume_24h_btc": 16.469737512585876,
    "rank": 24
  },
  {
    "id": "coinw",
    "name": "CoinW",
    "image": "/exchange-logos/coinw.png",
    "year_established": 2017,
    "country": "United Arab Emirates",
    "trust_score": 8,
    "trust_score_rank": 25,
    "trade_volume_24h_btc": 21721.075204122317,
    "rank": 25
  },
  {
    "id": "weex",
    "name": "WEEX",
    "image": "/exchange-logos/weex.png",
    "year_established": 2018,
    "country": "Singapore",
    "trust_score": 8,
    "trust_score_rank": 26,
    "trade_volume_24h_btc": 17598.283982723726,
    "rank": 26
  },
  {
    "id": "digifinex",
    "name": "DigiFinex",
    "image": "/exchange-logos/digifinex.png",
    "year_established": 2018,
    "country": "Seychelles",
    "trust_score": 8,
    "trust_score_rank": 27,
    "trade_volume_24h_btc": 13608.69069608801,
    "rank": 27
  },
  {
    "id": "lbank",
    "name": "LBank",
    "image": "/exchange-logos/lbank.png",
    "year_established": 2015,
    "country": "British Virgin Islands",
    "trust_score": 8,
    "trust_score_rank": 28,
    "trade_volume_24h_btc": 13740.115648939138,
    "rank": 28
  },
  {
    "id": "bitmart",
    "name": "BitMart",
    "image": "/exchange-logos/bitmart.png",
    "year_established": 2017,
    "country": "Cayman Islands",
    "trust_score": 8,
    "trust_score_rank": 29,
    "trade_volume_24h_btc": 10585.912528081639,
    "rank": 29
  },
  {
    "id": "ourbit",
    "name": "Ourbit",
    "image": "/exchange-logos/ourbit.png",
    "year_established": 2020,
    "country": "British Virgin Islands",
    "trust_score": 8,
    "trust_score_rank": 30,
    "trade_volume_24h_btc": 8529.190437471698,
    "rank": 30
  },
  {
    "id": "toobit",
    "name": "Toobit",
    "image": "/exchange-logos/toobit.png",
    "year_established": 2022,
    "country": "Cayman Islands",
    "trust_score": 8,
    "trust_score_rank": 31,
    "trade_volume_24h_btc": 10616.468731985933,
    "rank": 31
  },
  {
    "id": "p2pb2b",
    "name": "P2B",
    "image": "/exchange-logos/p2pb2b.png",
    "year_established": 2018,
    "country": "Lithuania",
    "trust_score": 8,
    "trust_score_rank": 32,
    "trade_volume_24h_btc": 11910.751372510373,
    "rank": 32
  },
  {
    "id": "upbit",
    "name": "Upbit",
    "image": "/exchange-logos/upbit.png",
    "year_established": 2017,
    "country": "South Korea",
    "trust_score": 8,
    "trust_score_rank": 33,
    "trade_volume_24h_btc": 12039.647622134426,
    "rank": 33
  },
  {
    "id": "xt",
    "name": "XT.COM",
    "image": "/exchange-logos/xt.png",
    "year_established": 2018,
    "country": "Seychelles",
    "trust_score": 8,
    "trust_score_rank": 34,
    "trade_volume_24h_btc": 9785.958548004735,
    "rank": 34
  },
  {
    "id": "tapbit",
    "name": "Tapbit",
    "image": "/exchange-logos/tapbit.png",
    "year_established": 2019,
    "country": "United States",
    "trust_score": 8,
    "trust_score_rank": 35,
    "trade_volume_24h_btc": 15122.505007389693,
    "rank": 35
  },
  {
    "id": "coinstore",
    "name": "Coinstore",
    "image": "/exchange-logos/coinstore.png",
    "year_established": 2020,
    "country": "Singapore",
    "trust_score": 8,
    "trust_score_rank": 36,
    "trade_volume_24h_btc": 8689.852432586655,
    "rank": 36
  },
  {
    "id": "bigone",
    "name": "BigONE",
    "image": "/exchange-logos/bigone.png",
    "year_established": 2017,
    "country": "Seychelles",
    "trust_score": 8,
    "trust_score_rank": 37,
    "trade_volume_24h_btc": 4690.353539518669,
    "rank": 37
  },
  {
    "id": "biconomy",
    "name": "Biconomy.com",
    "image": "/exchange-logos/biconomy.png",
    "year_established": 2019,
    "country": "British Virgin Islands",
    "trust_score": 8,
    "trust_score_rank": 38,
    "trade_volume_24h_btc": 4210.776098815169,
    "rank": 38
  },
  {
    "id": "bitrue",
    "name": "Bitrue",
    "image": "/exchange-logos/bitrue.png",
    "year_established": 2018,
    "country": "Seychelles",
    "trust_score": 8,
    "trust_score_rank": 39,
    "trade_volume_24h_btc": 5175.86552978838,
    "rank": 39
  },
  {
    "id": "dextrade",
    "name": "Dex-Trade",
    "image": "/exchange-logos/dextrade.png",
    "year_established": 2019,
    "country": "Belize",
    "trust_score": 8,
    "trust_score_rank": 40,
    "trade_volume_24h_btc": 1275.7967471082686,
    "rank": 40
  },
  {
    "id": "coinex",
    "name": "CoinEx",
    "image": "/exchange-logos/coinex.png",
    "year_established": 2017,
    "country": "Samoa",
    "trust_score": 8,
    "trust_score_rank": 41,
    "trade_volume_24h_btc": 1601.7989173280569,
    "rank": 41
  },
  {
    "id": "bitstamp",
    "name": "Bitstamp",
    "image": "/exchange-logos/bitstamp.png",
    "year_established": 2011,
    "country": "Luxembourg",
    "trust_score": 8,
    "trust_score_rank": 42,
    "trade_volume_24h_btc": 1660.280838440584,
    "rank": 42
  },
  {
    "id": "btse",
    "name": "BTSE",
    "image": "/exchange-logos/btse.png",
    "year_established": 2018,
    "country": "British Virgin Islands",
    "trust_score": 8,
    "trust_score_rank": 43,
    "trade_volume_24h_btc": 1665.251617580637,
    "rank": 43
  },
  {
    "id": "bitfinex",
    "name": "Bitfinex",
    "image": "/exchange-logos/bitfinex.png",
    "year_established": 2012,
    "country": "British Virgin Islands",
    "trust_score": 8,
    "trust_score_rank": 44,
    "trade_volume_24h_btc": 2383.6427212203275,
    "rank": 44
  },
  {
    "id": "bitbank",
    "name": "Bitbank",
    "image": "/exchange-logos/bitbank.png",
    "year_established": 2016,
    "country": "Japan",
    "trust_score": 8,
    "trust_score_rank": 45,
    "trade_volume_24h_btc": 453.00427447369503,
    "rank": 45
  },
  {
    "id": "coincatch",
    "name": "CoinCatch",
    "image": "/exchange-logos/coincatch.png",
    "year_established": 2022,
    "country": "British Virgin Islands",
    "trust_score": 8,
    "trust_score_rank": 46,
    "trade_volume_24h_btc": 420.3449860101331,
    "rank": 46
  },
  {
    "id": "bitcastle",
    "name": "bitcastle",
    "image": "/exchange-logos/bitcastle.png",
    "year_established": 2019,
    "country": "Lithuania",
    "trust_score": 8,
    "trust_score_rank": 47,
    "trade_volume_24h_btc": 297.1154489478083,
    "rank": 47
  },
  {
    "id": "indodax",
    "name": "Indodax",
    "image": "/exchange-logos/indodax.png",
    "year_established": 2014,
    "country": "Indonesia",
    "trust_score": 8,
    "trust_score_rank": 48,
    "trade_volume_24h_btc": 253.13973236045254,
    "rank": 48
  },
  {
    "id": "bitopro",
    "name": "BitoPro",
    "image": "/exchange-logos/bitopro.png",
    "year_established": 2018,
    "country": "Taiwan",
    "trust_score": 8,
    "trust_score_rank": 49,
    "trade_volume_24h_btc": 253.5954409602428,
    "rank": 49
  },
  {
    "id": "bitso",
    "name": "Bitso",
    "image": "/exchange-logos/bitso.png",
    "year_established": 2014,
    "country": "Gibraltar",
    "trust_score": 8,
    "trust_score_rank": 50,
    "trade_volume_24h_btc": 246.318628378134,
    "rank": 50
  }
];

// Export for easy access
export const EXCHANGE_IDS = TOP_50_EXCHANGES.map(exchange => exchange.id);
export const EXCHANGE_MAP = new Map(TOP_50_EXCHANGES.map(exchange => [exchange.id, exchange]));
